import { PageLoader } from 'cat-ecommerce-alloy';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { ERROR_DOMAIN, ERROR_PATH } from '../../../constants/errorConstants';
import { CMC_MARKETING_TARGET } from '../../../constants/targets';
import { useEspot, usePopulateDataLayer } from '../../../hooks';
import { setError } from '../../../store/exception/actions';
import { normalizeError } from '../../../store/exception/utils';
import ExceptionFeedbackBySelector from '../../common/Exception/ExceptionFeedbackBySelector';
import { GA_TRACKING_TEMPLATE_NAME } from './constants';
import useLayoutService from './hooks/useLayoutService';
import styles from './marketing.module.scss';
import TemplateManager from './TemplateManager';
import '@app/special-characters-support.scss';

const MarketingPageContainer = () => {
  const errors = useSelector(state => state.errors);
  const dispatch = useDispatch();
  const location = useLocation();

  const { layoutData, espotNames, isLayoutLoading } = useLayoutService();
  const { espotData, isEspotLoading, espotError, getEspotContent } =
    useEspot(espotNames);

  useEffect(() => {
    if (espotError) {
      dispatch(
        setError(
          ERROR_DOMAIN.MARKETING,
          ERROR_PATH.PAGE_LAYOUT,
          normalizeError(espotError)
        )
      );
    }
  }, [espotError, dispatch]);

  const urlArr = location.pathname.split('/');
  const urlParam = urlArr[urlArr.length - 1];
  const templateName = `${GA_TRACKING_TEMPLATE_NAME} ${urlParam}`;
  usePopulateDataLayer(templateName);

  const getErrorOrLoading = () => {
    if (!!errors?.[ERROR_DOMAIN.MARKETING]?.[ERROR_PATH.PAGE_LAYOUT]) {
      return (
        <div className="mt-3" data-testid="marketing-page-error">
          <ExceptionFeedbackBySelector
            selector={state =>
              state.errors?.[ERROR_DOMAIN.MARKETING]?.[ERROR_PATH.PAGE_LAYOUT]
            }
            errorCodeLabel={'MLP_ERROR4'}
            showContactUs={true}
          />
        </div>
      );
    }
    if (isLayoutLoading || isEspotLoading) {
      return <PageLoader />;
    }
    return null;
  };

  return createPortal(
    <div className={`${styles['marketing-page__container']}`}>
      {getErrorOrLoading() || (
        <TemplateManager
          layoutData={layoutData}
          espotData={espotData || {}}
          getEspotContent={getEspotContent}
        />
      )}
    </div>,
    document.getElementById(CMC_MARKETING_TARGET)
  );
};

export default MarketingPageContainer;
